import tpl from './reminder.tpl.html';
import './reminder.modal.scss';

import uibModalModule from 'angular-ui-bootstrap/src/modal';
import normalButtonComponentMod from '../../../common/material-components/buttons/normal-button.component';


/**
 * Refresh the keepalive modal countdown every this many seconds.
 * @type {number}
 */
const COUNTDOWN_REFRESH = 5;

class ReminderModalComponent {
  constructor($interval) {
    'ngInject';

    this.$interval = $interval;
    this.resolve = null;

    /**
     * Time of the expiry of the user's session.
     * @type {Moment}
     */
    this.timeAt = null;

    /**
     * Function to close and resolve this modal with a value.
     * @type {function}
     */
    this.close = null;

    /**
     * Function to close and reject this modal with a value.
     * @type {function}
     */
    this.dismiss = null;

    /**
     * Duration to the expiry time in human readable form.
     * @type {string}
     */
    this.humanDuration = '';

    this._refreshInterval = null;
  }

  $onInit() {
    this.timeAt = this.resolve.timeAt;

    this.updateDuration();

    this._refreshInterval = this.$interval(() => this.updateDuration(), COUNTDOWN_REFRESH * 1000);
  }

  $onDestroy() {
    this.$interval.cancel(this._refreshInterval);
  }

  updateDuration() {
    this.humanDuration = this.timeAt.fromNow(true);
  }
}

const config = {
  templateUrl: tpl,
  controller: ReminderModalComponent,
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&'
  }
};

const mod = angular.module('app.common.keepalive.reminderModal', [
  uibModalModule,
  normalButtonComponentMod
])

.component('keepaliveReminderModal', config)
.factory('openReminderModal', function ($uibModal) {
  return timeAt => $uibModal.open({
    component: 'keepaliveReminderModal',
    size: 'md',
    resolve: {timeAt: () => timeAt},
    keyboard: false,
    backdrop: 'static',
    windowClass: 'reminder-modal',
    backdropClass: 'reminder-modal-backdrop'
  });
});

export default mod.name;
